import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38c0d4ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "content item-center" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "cards-container" }
const _hoisted_6 = { class: "donate-name" }
const _hoisted_7 = { class: "donate-bonuses" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "per" }
const _hoisted_11 = { class: "error-text" }

import {ref, WritableComputedRef} from "vue";
import {SubscriptionType} from "@/types/SubscriptionType";
import config from "@/config.json";
import i18n from "@/plugins/i18n";
import {loginUrl} from "@/utils/LoginUrl";
import {PaymentResponse} from "@/types/PaymentResponse";

import {Language} from "@/types/Language";


export default /*#__PURE__*/_defineComponent({
  __name: 'DonateView',
  setup(__props) {

let loading = ref(false)
let snackbar = ref(false)

async function payment(type: SubscriptionType) {
  let token = localStorage.getItem('token')
  if (!token) window.location.replace(loginUrl())
  let locale = i18n.global.locale as WritableComputedRef<Language>
  let language: Language = locale.value === "ru" ? "en" : "ru"
  loading.value = true
  let response = await fetch(`${config.API}/private/payments`,
      {
        method: 'POST',
        headers: {
          Authorization: token as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({
          type,
          language: language
        })
      })
  let body: PaymentResponse = await response.json()
  if (response.ok) window.location.replace(body.confirmationUrl)
  else {
    snackbar.value = true
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('Donate.name')), 1)
      ]),
      _createElementVNode("div", {
        class: "donate-description",
        innerHTML: _ctx.$t('Donate.description')
      }, null, 8, _hoisted_4),
      _createVNode(_component_v_expansion_panels, { variant: "accordion" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Donate.features'), (feature) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, { "bg-color": "block" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, {
                  class: "feature-name",
                  ripple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "category-icon" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$rt(feature.icon)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createTextVNode(" " + _toDisplayString(_ctx.$rt(feature.name)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, {
                  class: "feature-description",
                  color: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$rt(feature.description)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Donate.cards'), (card, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`donate-card donate-card-${i}`)
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$rt(card.name)), 1),
            _createVNode(_component_v_divider, { class: "donate-card-divider" }),
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm(`Donate.cards.${i}.perks`), (perk) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(`donate-bonus-${i} donate-bonus`)
                }, [
                  (!_ctx.$rt(perk).includes('[R]'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$rt(perk)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.$rt(perk).split('[R]')[0]) + " ", 1),
                        (i !== 'premium')
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              variant: "outlined",
                              color: "#4caf50"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Donator")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_chip, {
                              key: 1,
                              variant: "outlined",
                              color: "#007bff"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Premium Donator")
                              ]),
                              _: 1
                            })),
                        _createTextVNode(" " + _toDisplayString(_ctx.$rt(perk).split('[R]')[1]), 1)
                      ]))
                ], 2))
              }), 256))
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_divider, { class: "donate-card-divider" }),
            _createVNode(_component_v_btn, {
              class: "donate-buy",
              theme: "dark",
              color: i === 'premium' ? '#007bff' : '#4caf50',
              width: 220,
              height: 40,
              loading: _unref(loading),
              onClick: ($event: any) => (payment(i))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$rt(card.price)) + "₽", 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('Donate.perMonth')), 1)
              ]),
              _: 2
            }, 1032, ["color", "loading", "onClick"])
          ])
        ], 2))
      }), 256))
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(snackbar),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(snackbar) ? (snackbar).value = $event : snackbar = $event)),
      color: "block"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "pink",
          variant: "text",
          ripple: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(snackbar) //@ts-ignore
 ? snackbar.value = false : snackbar = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Donate.close')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Donate.error')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})